var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmunization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 50",
    style: {
      enableBackground: "new 0 0 92 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#11C79E;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#27CFA9;}\n\t.st3{opacity:0.4119;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n\t.st4{opacity:0.8703;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#0A9A7A;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#68F3D4;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#33AE80;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#7BE3CC;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "immunization") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "immunization"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(6.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M18.2,6c6.5-1,5.5,9.1,7.3,13.2c1.2,2.9,3.9,6.4,3,9.8c-1.2,3.8-5.9,6.3-9.4,6.9 c-5.9,1.2-18,0.6-18.1-7.8c0-3.1,1.5-6.4,2-9.5C3.3,14.9,3.3,10,6,7.2c2.6-2.8,6.7-3.1,9.4-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st1",
    d: "M14,30c4.4,0,8-5,8-9.5S18.4,14,14,14s-8,2.1-8,6.5S9.6,30,14,30z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.686432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st2",
    d: "M18.2,2.9c0.8,7.8-8.9,6.8-12,11.5C4.4,10.2,5.3,1.8,9.9,0.3c2.3-0.8,7.7-0.2,8,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st2",
    d: "M14.1,6.9c0.7,2.8,3.9,5.1,5.2,7.7c1.5-2.1,3.1-9.6-0.4-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st3",
    d: "M15.9,5.9l-0.4,0.5c-0.1,0.2-0.2,0.3-0.4,0.4l-0.4,0.4c-0.1,0.1-0.3,0.3-0.4,0.4L13.7,8 c-0.2,0.1-0.3,0.2-0.5,0.4l-1,0.7l-1,0.6c-0.4,0.2-0.7,0.3-1.1,0.5c-0.2,0.1-0.4,0.1-0.6,0.2L9,10.5c-0.2,0.1-0.4,0.1-0.6,0.2 l-0.6,0.2l-0.6,0.2l0.4-0.5C8,10.1,8.3,9.9,8.5,9.6c0.1-0.1,0.2-0.3,0.3-0.4C8.9,9.1,9,9,9,8.9l0.1-0.3l0.3,0.2L8.9,9.2 C8.7,9.3,8.5,9.4,8.4,9.5C8.2,9.6,8,9.7,7.8,9.7L7.3,10c-0.2,0-0.4,0.1-0.6,0.1l-0.3,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0 l-0.6,0l-0.3,0l0.2-0.2l0.4-0.4l0.4-0.3l0.8-0.6l0.4-0.3L7.3,8c0.1-0.1,0.2-0.3,0.3-0.4l0.3-0.4L7.7,7.6C7.6,7.8,7.4,7.9,7.3,8 L7,8.4L6.6,8.8C6.3,9,6,9.2,5.8,9.4L5.4,9.8L5,10.1L4.9,9.9l0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4-0.1,0.6-0.1 c0.2,0,0.4-0.1,0.5-0.1l0.5-0.2C7.9,9.3,8,9.2,8.2,9.1C8.4,9,8.5,9,8.7,8.9l0.5-0.3l0.5-0.3L9.5,8.7L9.4,9.1 c0,0.1-0.1,0.2-0.2,0.3C9.1,9.5,9,9.7,8.8,9.9c-0.1,0.2-0.3,0.3-0.4,0.4c-0.1,0.1-0.3,0.3-0.4,0.4l-0.2-0.3l0.6-0.1 c0.2,0,0.4-0.1,0.6-0.1l0.5-0.2C9.7,9.8,9.8,9.8,10,9.7c0.4-0.2,0.7-0.3,1.1-0.5l1-0.5l1-0.6c0.3-0.2,0.6-0.5,1-0.7 c0.2-0.1,0.3-0.2,0.5-0.4L15,6.7c0.1-0.1,0.3-0.3,0.4-0.4L15.9,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.4,1.8L0.4,1.8c0.1-0.1,4.3-1.4,8-1.4c3,0,8.2,1.4,8.2,1.4l-1,6.2c0,0-4.9-1.1-7.2-1.1c-2.5,0-6.9,1-6.9,1 L0.4,1.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M8.3,6.3c2.1,0,5.9,0.8,7,1l0.9-5.5c-1.1-0.3-5.3-1.3-7.9-1.3c-3.1,0-6.7,0.9-7.7,1.2l1,5.5 C2.7,7,6.2,6.3,8.3,6.3z M15.8,8l-0.3-0.1c0,0-4.9-1.1-7.2-1.1c-2.4,0-6.8,1-6.8,1L1.2,7.9L1.2,7.6L0.1,1.7L0,1.4l0.3-0.1 C0.7,1.2,4.8,0,8.3,0c3,0,8.1,1.3,8.3,1.4l0.2,0.1L15.8,8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10,3.1 8.7,3.1 8.7,1.9 7.5,1.9 7.5,3.1 6.2,3.1 6.2,4.1 7.5,4.1 7.5,5.3 8.7,5.3 8.7,4.1 10,4.1  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval-2",
    className: "st0",
    d: "M13.5,46C21,46,27,46.3,27,41.8S20.2,30,13.5,30S0,37.3,0,41.8S6,46,13.5,46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "st4",
    d: "M6.7,32.7c0.6,0.9,0.9,1.5,0.9,1.9c0,0.4-0.2,0.8-0.8,1.1c1.3,0,2.4,0.3,3.3,0.7 c0.9,0.4,2.1,1.3,3.8,2.7c-0.7-2.8-1.5-4.7-2.4-5.5C10.6,32.8,9,32.5,6.7,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2-Copy",
    className: "st4",
    d: "M20.3,32.7c-0.6,0.9-0.9,1.5-0.9,1.9c0,0.4,0.2,0.8,0.8,1.1c-1.3,0-2.4,0.3-3.3,0.7 c-0.9,0.4-2.1,1.3-3.8,2.7c0.7-2.8,1.5-4.7,2.4-5.5C16.4,32.8,18,32.5,20.3,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-24",
    className: "st4",
    d: "M13.5,39L13.5,39c0.3,0,0.5,0.2,0.5,0.5V46h-1v-6.5C13,39.2,13.2,39,13.5,39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(38.500000, 31.000000) rotate(105.000000) translate(-38.500000, -31.000000) translate(27.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.6,5.1 18.7,5.1 18.7,0.7 7.6,0.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st5",
    points: "21.2,5.1 22.1,5.1 22.1,0.7 21.2,0.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.7,0.6c0,0-1.7,1.9,0,4.3V0.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "st6",
    points: "10.2,3.6 21.3,3.6 21.3,1.9 10.2,1.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "st7",
    points: "6.9,2.9 6.9,2.7 1.2,2.7 0.5,2.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.4,3.3 7,3.3 7,2.2 5.4,2.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "st5",
    points: "9.5,4.5 10.5,4.5 10.5,1 9.5,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "st5",
    points: "18.3,5.5 19.2,5.5 19.2,0 18.3,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st1",
    points: "8.8,4.9 9,4.9 9,4.5 8.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "st1",
    points: "9.4,4.9 9.6,4.9 9.6,4.5 9.4,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "st1",
    points: "10,4.9 10.2,4.9 10.2,4.5 10,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "st1",
    points: "10.6,4.9 10.8,4.9 10.8,4.5 10.6,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "st1",
    points: "11.2,4.9 11.4,4.9 11.4,4.1 11.2,4.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    className: "st1",
    points: "11.8,4.9 12,4.9 12,4.5 11.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    className: "st1",
    points: "12.4,4.9 12.6,4.9 12.6,4.5 12.4,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    className: "st1",
    points: "13,4.9 13.2,4.9 13.2,4.5 13,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    className: "st1",
    points: "13.6,4.9 13.8,4.9 13.8,4.5 13.6,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    className: "st1",
    points: "14.3,4.9 14.4,4.9 14.4,4.1 14.3,4.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    className: "st1",
    points: "14.9,4.9 15,4.9 15,4.5 14.9,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    className: "st1",
    points: "15.5,4.9 15.6,4.9 15.6,4.5 15.5,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "st1",
    points: "16.1,4.9 16.3,4.9 16.3,4.5 16.1,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    className: "st1",
    points: "16.7,4.9 16.9,4.9 16.9,4.5 16.7,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    className: "st1",
    points: "17.3,4.9 17.5,4.9 17.5,4.1 17.3,4.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    className: "st7",
    d: "M0.4,3.2C0.1,3.6-0.4,5.1,0.6,4.8C1.3,4.6,0.7,3.7,0.4,3.2L0.4,3.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "children",
    transform: "translate(47.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.4,8.4c0,0-1.6-0.2-2.2,1.5c-0.6,1.7,0.1,3.6,1.7,4.1c0,0-0.4-3.1,0.7-4L2.4,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,4.5c0,0,1.4-0.9,2.6,0.4c1.2,1.3,1.3,3.3,0.1,4.4c0,0-0.9-3-2.3-3.3L14.8,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15.1,7.6c0.3-0.3,0.7-0.7,1.1-0.6c0.4,0.1,0.7,0.6,0.7,1c0,0.6-0.2,1.3-0.7,1.7c-0.4,0.5-1,0.7-1.6,0.8 L15.1,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.5,10.5c-0.4-0.2-0.9-0.4-1.3-0.2c-0.4,0.2-0.5,0.8-0.4,1.2C2,12.1,2.4,12.7,3,13 c0.5,0.3,1.2,0.4,1.8,0.3L3.5,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.8,17.8c1.2,0.3,1.8-0.3,2-0.8c0.2-0.5-0.1-2.3-0.4-2.6c-0.3-0.4-2.5,0.2-2.5,0.2S8.6,17.5,9.8,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.4,15.5c4.4-0.4,6.6-2.9,6.2-6.6c-0.1-1.2-0.3-2.7-0.3-2.7C13.4,3.5,5.2,4,3,8.8c0,0,0,0.6,0.1,1.7 C3.5,14.5,6.4,15.7,9.4,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,11C2.8,10.9-1.3,2.1,7.5,0.3c9.3-1.9,8.4,6.9,8.1,8c0,0-0.4-2.1-1.2-2.3c-0.7,0.4-2.8,1.1-3.4,1.3 c-0.8-0.2-0.7-0.8-0.7-0.8s-0.2,0.6,0.1,1C9.6,7.8,8.4,8.1,7.6,8.3C7.1,8,7,7.3,7,7.3S6.8,8.1,7,8.4C5.6,8.8,4.3,9,3.6,9.1 C3,10,3.2,11,3.2,11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy",
    transform: "translate(21.518072, 0.465517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.6,7.6c0.3-0.3,0.7-0.7,1.1-0.6c0.4,0.1,0.7,0.6,0.7,1.1c0,0.7-0.2,1.3-0.6,1.8c-0.4,0.5-1,0.7-1.6,0.8 L14.6,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1.9,10.1c-0.4-0.2-1-0.5-1.4-0.2C0,10.1-0.1,10.7,0,11.1c0.2,0.7,0.6,1.2,1.3,1.5c0.6,0.3,1.3,0.4,2,0.3 L1.9,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M8.7,17.5c1.3,0.3,2-0.3,2.2-0.8c0.2-0.5-0.1-2.4-0.4-2.7c-0.3-0.4-2.8,0.2-2.8,0.2S7.4,17.2,8.7,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M8.3,14.9c4.6-0.4,6.9-2.8,6.5-6.4c-0.1-1.1-0.3-2.6-0.3-2.6C12.5,3.2,4,3.7,1.6,8.4c0,0,0.1,0.6,0.1,1.7 C2.1,13.9,5.2,15.2,8.3,14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,10.9C1.3,10.8-3.1,2.1,6.3,0.3c9.9-1.9,8.9,6.8,8.6,7.9c0,0-0.4-2.1-1.3-2.2c-0.7,0.4-3,1.1-3.6,1.3 C9.2,7.1,9.3,6.6,9.3,6.6s-0.2,0.6,0.1,1C8.5,7.7,7.3,8,6.4,8.2c-0.5-0.3-0.6-1-0.6-1S5.6,8,5.7,8.4C4.3,8.7,2.9,9,2.1,9 C1.5,9.9,1.8,10.9,1.8,10.9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Oval-11",
    className: "st0",
    d: "M10.5,26.8c3.8,0,6.9,0,6.9-3.5s-3.1-7.4-6.9-7.4s-6.9,4-6.9,7.4S6.7,26.8,10.5,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-11-Copy",
    className: "st0",
    d: "M31.1,26.8c3.8,0,6.9,0,6.9-3.5s-3.1-7.4-6.9-7.4s-6.9,4-6.9,7.4S27.3,26.8,31.1,26.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmunization);
export default __webpack_public_path__ + "static/media/immunization.8205191112fbd559b37891ec13e9f612.svg";
export { ForwardRef as ReactComponent };